import http from '@/http'
import apiUrl from '@/config'

const state = {
  statuses: []
}

const getters = {
  getStatuses: (state) => {
    return state.statuses
  }
}

const mutations = {
  SET_STATUSES (state, data) {
    state.statuses = data.statuses
  }
}

const actions = {
  checkStatuses ({ commit, state }, payload) {
    if (state.statuses.length > 0) return Promise.resolve()

    return http.post(apiUrl.replacement_process_status_list).then(response => {
      const result = response.data
      if (result.status === true) {
        return commit('SET_STATUSES', { statuses: result.list })
      } else {
        return Promise.reject(new Error(result.message))
      }
    }).catch(function (error) {
      console.log('Replacement:checkStatuses:catch(error): ', error)
      return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
